export default function TrustSection() {
  const trustItems = [
    {
      icon: 'ri-shield-check-line',
      title: 'Expert Researched',
      desc: 'Every product entry is verified and curated by experienced Sugargoo shoppers who understand quality and value.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regularly Updated',
      desc: 'Our spreadsheets receive daily updates to ensure you always have access to the latest trending products and deals.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparent Information',
      desc: 'We provide honest, unfiltered product details including real pricing, quality notes, and practical shopping tips.',
    },
    {
      icon: 'ri-star-line',
      title: 'Independent Reviews',
      desc: 'Our content is independently created. We are not paid by sellers — our recommendations are based on real user experiences.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Beginner Guides',
      desc: 'New to Sugargoo? Our step-by-step guides walk you through everything from account setup to your first purchase.',
    },
    {
      icon: 'ri-group-line',
      title: 'Community Driven',
      desc: 'Join thousands of shoppers who contribute product discoveries, share reviews, and help each other find the best deals.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Why Trust This Resource
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Built By Shoppers,{' '}
            <span className="text-primary-600 italic">For Shoppers</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            We take product discovery seriously. Every spreadsheet, guide, and recommendation is crafted with care
            to give you the most reliable Sugargoo shopping experience possible.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${item.icon} text-lg text-accent-700`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}